import { AddUploadFileExpenseType } from "../../../domain/useages/expense-dashboard/add-upload-file-expense";
import { HttpConstants } from "../../protocols/http/http-constants";
import { HttpPostClient } from "../../protocols/http/http-post-client";

export class RemoteAddUploadFileExpense implements AddUploadFileExpenseType {
  constructor(
    private readonly url: string,
    private readonly httpPostClient: HttpPostClient
  ) {}

  async add(params: AddUploadFileExpenseType.Params): Promise<any> {
    const formData = new FormData();
    formData.append("expense_id", params.expense_id);
    formData.append("file", params.file);

    const httpResponse = await this.httpPostClient.post({
      url: this.url,
      body: formData,
      headers: {
        [HttpConstants.ACCEPT]: HttpConstants.APPLICATION_JSON,
        [HttpConstants.APP_ID]: HttpConstants.APP_ID_VALUE,
      },
      authHeaders: true,
    });
    return httpResponse.data;
  }
}
